<template>
  <div>
    <h2 class="text-base font-medium text-gray-600 mb-2">Pages</h2>
    <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 xl:gap-x-8">
      <li v-for="page in pages" :key="page.id" class="relative">
        <ProjectPageManagerTile :page="page" :order-item-id="orderItemId" />
      </li>
    </ul>
  </div>
</template>

<script>
import ProjectPageManagerTile from './ProjectPageManagerTile.vue';

const STATUS_IDLE = 'STATUS_IDLE';
const STATUS_INITIALIZING = 'STATUS_INITIALIZING';
const STATUS_PENDING = 'STATUS_PENDING';
const STATUS_RESOLVED = 'STATUS_RESOLVED';
const STATUS_REJECTED = 'STATUS_REJECTED';

export default {
  components: {
    ProjectPageManagerTile,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    orderItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      status: STATUS_IDLE,
    };
  },
  computed: {
    isStatusPending() {
      return this.status === STATUS_PENDING;
    },
    pages() {
      return this.$store.getters['ui/projectPages/itemsByParent'](this.projectId);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.status = STATUS_INITIALIZING;
      this.fetchProjectPages();
    },
    async fetchProjectPages(params = {}) {
      try {
        await this.$store.dispatch('ui/projectPages/load', {
          projectUuid: this.projectId,
          params: {
            ...params,
          },
        });

        this.status = STATUS_RESOLVED;
      } catch (error) {
        this.status = STATUS_REJECTED;
      }
    },
    addProjectAsset(asset) {
      this.$emit('add-asset', asset);
    },
  },
};
</script>
